import React, { useRef, useState } from "react";
import { Form } from "react-bootstrap";
import Form_Header from "../../../common/form-header/Form_Header";
import Common_Btn from "../../../common/common-btn/Common_Btn";
import White_Btn from "../../../common/common-btn/white-btn/White_Btn";
import "./Create_Step4.css";
import Preview_Modal from "../../../common/common-modal/preview-modal/Preview_Modal";

const Create_Step4 = ({ step, totalSteps, setStep }) => {
  const [showDocs, setShowDocs] = useState(false);
  const [selectedType, setSelectedType] = useState("");

  // -------- Multiple files --------
  const fileRefs = {
    propertyTax: useRef(null),
    electricity: useRef(null),
    saleDeed: useRef(null),
  };

  const [files, setFiles] = useState({
    propertyTax: null,
    electricity: null,
    saleDeed: null,
  });

  // -------- Single file --------
  const singleFileRef = useRef(null);
  const [singleFile, setSingleFile] = useState(null);

  // -------- Modal --------
  const [modalShow, setModalShow] = useState(false);
  const [modalFile, setModalFile] = useState(null);

  // -------- Handlers --------
  const handleFileChange = (type, e) => {
    const file = e.target.files[0];
    if (!file) return;

    setFiles((prev) => ({
      ...prev,
      [type]: {
        file,
        name: file.name,
        preview: URL.createObjectURL(file),
      },
    }));
  };

  const handleSingleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setSingleFile({
      file,
      name: file.name,
      preview: URL.createObjectURL(file),
    });
  };

  const openPreviewModal = (file) => {
    setModalFile(file);
    setModalShow(true);
  };

  const handleFileButtonClick = (type) => {
    if (files[type]?.preview) {
      openPreviewModal(files[type]);
    } else {
      fileRefs[type].current.click();
    }
  };

  const handleSingleButtonClick = () => {
    if (singleFile?.preview) {
      openPreviewModal(singleFile);
    } else {
      singleFileRef.current.click();
    }
  };

  // ---------------- DOCUMENT PAGE ----------------
  if (showDocs) {
    return (
      <section className="step3_wrapper step1_wrapper step4_wrapper">
        <Form_Header
          title="Business Address Proof"
          subtitle=""
          step={4}
          totalSteps={6}
        />

        <div className="container mt-4">
          <div className="doc_header">
            <h5 className="doc_title">{selectedType}</h5>
            <span className="doc_info">
              Owned Property (Any 2 of the following)
            </span>
          </div>

          <h5 className="doc_back" onClick={() => setShowDocs(false)}>
            Back
          </h5>

          <div className="row mt-4">
            {[
              { label: "Property Tax Receipt", key: "propertyTax" },
              {
                label: "Electricity Bill (not older than 2 months)",
                key: "electricity",
              },
              { label: "Sale Deed", key: "saleDeed" },
            ].map((item) => (
              <div className="col-lg-6 mb-4" key={item.key}>
                <Form.Group>
                  <Form.Label>{item.label}</Form.Label>

                  <div className="file_upload_wrapper">
                    <span className="file_placeholder">
                      {files[item.key]?.name || "No File Uploaded"}
                    </span>

                    <div
                      className="upload_btn"
                      onClick={() => handleFileButtonClick(item.key)}
                    >
                      <Common_Btn
                        btnText={files[item.key] ? "Preview" : "Upload file"}
                      />
                    </div>

                    <input
                      ref={fileRefs[item.key]}
                      type="file"
                      accept="image/*"
                      hidden
                      onChange={(e) => handleFileChange(item.key, e)}
                    />
                  </div>
                </Form.Group>
              </div>
            ))}
          </div>

          <div className="text-center mt-4 form_btn_holder">
            <Common_Btn btnText="Done" onClick={() => setShowDocs(false)} />
          </div>
        </div>

        {/* Common Document Modal */}
        <Preview_Modal
          show={modalShow}
          onHide={() => setModalShow(false)}
          file={modalFile}
          onUploadNew={() => {
            if (modalFile === singleFile) {
              singleFileRef.current.click();
            } else {
              const key = Object.keys(files).find(
                (k) => files[k] === modalFile
              );
              fileRefs[key]?.current.click();
            }
          }}
          onDelete={() => {
            if (modalFile === singleFile) {
              setSingleFile(null);
            } else {
              const key = Object.keys(files).find(
                (k) => files[k] === modalFile
              );
              setFiles((prev) => ({ ...prev, [key]: null }));
            }
            setModalShow(false);
          }}
        />
      </section>
    );
  }

  // ---------------- MAIN FORM ----------------
  return (
    <section className="step4_wrapper step1_wrapper">
      <Form_Header
        title="Business Address Proof"
        subtitle=""
        step={4}
        totalSteps={6}
      />

      <div className="container">
        <Form className="auth_form">
          <div className="row">
            <div className="col-lg-12">
              <Form.Label>Proof of Principal Place of Business</Form.Label>
            </div>

            {["Owned Property", "Rented Property"].map((item, index) => (
              <div className="col-lg-6 mb-3" key={index}>
                <Form.Check
                  type="radio"
                  name="propertyType"
                  id={item}
                  className="radio_card_wrapper"
                  label={
                    <span className="radio_card">
                      <span className="radio_circle" />
                      {item}
                    </span>
                  }
                  onChange={() => {
                    setSelectedType(item);
                    setShowDocs(true);
                  }}
                />
              </div>
            ))}

            <div className="col-lg-6 mb-4">
              <Form.Group>
                <Form.Label>Cancelled Cheque / Bank Statement</Form.Label>

                <div className="file_upload_wrapper">
                  <span className="file_placeholder">
                    {singleFile?.name || "No File Uploaded"}
                  </span>

                  <div className="upload_btn" onClick={handleSingleButtonClick}>
                    <Common_Btn
                      btnText={singleFile ? "Preview" : "Upload file"}
                    />
                  </div>

                  <input
                    ref={singleFileRef}
                    type="file"
                    accept="image/*"
                    hidden
                    onChange={handleSingleFileChange}
                  />
                </div>
              </Form.Group>
            </div>
          </div>
        </Form>

        <div className="form_btn_holder">
          <White_Btn btnText="Back" onClick={() => setStep(3)} />
          <Common_Btn btnText="Next" onClick={() => setStep(5)} />
        </div>
      </div>

      {/* Modal for single file preview */}
      <Preview_Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        file={modalFile}
        onUploadNew={() => singleFileRef.current.click()}
        onDelete={() => {
          setSingleFile(null);
          setModalShow(false);
        }}
      />
    </section>
  );
};

export default Create_Step4;
